import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ProblemAlert } from '../../components/ProblemAlert';
import { useMe } from './useMe';

/**
 * W0 füstteszt-képernyő: bizonyítja, hogy a bejelentkezés, a token, a
 * same-origin API-hívás és az adatbázis-írás (az `/me` `appUser` upsertet
 * végez) végponttól végpontig működik.
 *
 * A W1-ben ez a képernyő adja majd át a helyét a valódi főmenünek.
 */
export function HomePage() {
  const me = useMe();

  if (me.isPending) {
    return (
      <Stack sx={{ py: 6, alignItems: 'center' }}>
        <CircularProgress />
      </Stack>
    );
  }

  if (me.isError) return <ProblemAlert error={me.error} />;

  return (
    <Stack spacing={2}>
      <Typography variant="h5" component="h2">
        Bejelentkezve
      </Typography>

      <Card variant="outlined" sx={{ maxWidth: 640 }}>
        <CardContent>
          <Stack spacing={1}>
            <Field label="Név" value={me.data.displayName} />
            <Field label="Bejelentkezési név" value={me.data.username} />
            <Field label="Azonosító (oid)" value={me.data.oid} />
            <Field label="Tenant" value={me.data.tenantId} />
          </Stack>
        </CardContent>
      </Card>

      <Typography variant="body2" color="text.secondary">
        A címkekonzol és a lokáció-adminisztráció a következő mérföldkőben (W1) készül el.
      </Typography>
    </Stack>
  );
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction="row" spacing={1}>
      <Typography variant="body2" sx={{ minWidth: 180, color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>
        {value}
      </Typography>
    </Stack>
  );
}
